// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Preloader_Loader__1fvwA","load2":"Preloader_load2__30QCn","Inverse":"Preloader_Inverse__11dKe","Dark":"Preloader_Dark__2Fqt5"};